import React from 'react';
import './404PageNotFound.scss';
import SEOUpdater from '../../utils/hoc/SEOUpdater';
import PagesHeroSection from '../../components/pagesHeroSection';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import Structured404 from '../../utils/structured404/structured404';
import { getCurrentLang } from '../../utils/withLang';

const PageNotFound = () => {
  const { t } = useTranslation('pageNotFound');
  const location = useLocation();

  const currentLang = getCurrentLang(location.pathname) || 'en';

  return (
    <div className="not-found-page">
      <SEOUpdater page="pageNotFound" noindex />
      <Structured404 />

      <PagesHeroSection page={t('heroTitle')} />

      <div className="not-found-page-content">
        <p style={{ fontSize: '20px', color: '#666' }}>{t('message')}</p>

        {/*
          Trailing slash matters here in a way it wouldn't have before today:
          this "Back to Home" link was effectively unreachable by react-snap's
          crawler until the approutes.jsx fix (unsupported /:lang now renders
          this page directly instead of redirecting away), so this is the
          first time this link has ever actually been crawled. Without the
          trailing slash, react-snap discovers "/en" as a brand new route,
          crawls it separately from the already-correct "/en/", and - because
          both write to the same build/en/index.html - the second crawl can
          overwrite the real homepage's prerendered file with a broken one
          (the "/en" no-slash URL doesn't match any real route past
          LangRedirect, so it hydrates a <Navigate> against a full page of
          content and throws). Matching every other internal link's
          convention (see withLang.js) avoids all of that.
        */}
        <Link
          to={`/${currentLang}/`}
          aria-label={t('backToHome', { defaultValue: 'Back to home' })}
          style={{ fontSize: '16px', color: '#007bff', textDecoration: 'none' }}
        >
          {t('backToHome')}
        </Link>
      </div>
    </div>
  );
};

export default PageNotFound;
